module.exports = __webpack_public_path__ + "static/img/Payne-Haas.80258fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Payne-Haas.jpg
// module id = ugiJ
// module chunks = 0